"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./CardHeader.css");

var _styles = {
  "title": "CardHeader__title___oWcl2",
  "no-bg-color": "CardHeader__no-bg-color___1Wt56"
};

const styles = _bind.default.bind(_styles);

const CardHeader = (0, _mobxReact.observer)(({
  className,
  children,
  title,
  titleSize,
  paddingTopBottom = 16,
  paddingLeftRight = 24,
  noBgColor,
  icon,
  iconColor,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('title', {
    'no-bg-color': noBgColor
  }), className);
  return _react.default.createElement(_.Content, {
    flex: true,
    flexDirection: 'row',
    className: composed_classname,
    paddingTop: paddingTopBottom,
    paddingBottom: paddingTopBottom,
    paddingLeft: paddingLeftRight,
    paddingRight: paddingLeftRight,
    justifyContent: children && 'space-between',
    alignItems: 'center',
    dataTestId: dataTestId,
    ...props
  }, typeof icon === 'string' ? _react.default.createElement(_.Icon, {
    name: icon,
    size: titleSize == 15 ? 24 : 32,
    color: iconColor
  }) : icon, title && _react.default.createElement(_.Text, {
    variant: 'medium',
    size: titleSize
  }, title), children);
});
CardHeader.defaultProps = {
  titleSize: 18,
  paddingLeftRight: 24,
  paddingTopBottom: 16
};
var _default = CardHeader;
exports.default = _default;